/**
 * Overrides for locales whose region hint is not the tag itself: `en` shows `us`
 * (the primary PAM market) rather than `en`. Everything else derives from the
 * tag, so a new operator locale needs no entry here.
 */
export const LANGUAGE_FLAGS: Record<string, string> = {
  en: "us",
};

export function getLanguageFlag(lng: string): string {
  return LANGUAGE_FLAGS[lng] || lng?.toLowerCase() || "🌐";
}
